/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { LoginRequest } from '../api-models';
// @ts-ignore
import { LoginResponse } from '../api-models';
// @ts-ignore
import { PasswordResetRequest } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { ProfileUpdateRequest } from '../api-models';
// @ts-ignore
import { RefreshTokenByJwtTokenRequest } from '../api-models';
// @ts-ignore
import { RefreshTokenByJwtTokenResponse } from '../api-models';
// @ts-ignore
import { RefreshTokenRequest } from '../api-models';
// @ts-ignore
import { RegisterRequestV2 } from '../api-models';
// @ts-ignore
import { RegisterResponseV2 } from '../api-models';
// @ts-ignore
import { ResetPasswordOtpRequest } from '../api-models';
// @ts-ignore
import { Response } from '../api-models';
// @ts-ignore
import { RetrieveUsernameOtpRequest } from '../api-models';
// @ts-ignore
import { SendOtpResponse } from '../api-models';
// @ts-ignore
import { SendOtpV2Response } from '../api-models';
// @ts-ignore
import { SendRegistrationOtpRequest } from '../api-models';
// @ts-ignore
import { UserProfileResponse } from '../api-models';
// @ts-ignore
import { ValidateUsernameResponse } from '../api-models';
// @ts-ignore
import { VerifyOtpForPasswordResettingRequest } from '../api-models';
// @ts-ignore
import { VerifyOtpForUserRetrievalRequest } from '../api-models';
// @ts-ignore
import { VerifyUsernameRequest } from '../api-models';
/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves the profile picture of an employee based on their employee ID and facility ID.
         * @param {number} employeeFacilityInstancePk The unique ID of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountEmployeeFacilityInstancePkEmployeeProfilePictureGet: async (employeeFacilityInstancePk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeFacilityInstancePk' is not null or undefined
            assertParamExists('accountEmployeeFacilityInstancePkEmployeeProfilePictureGet', 'employeeFacilityInstancePk', employeeFacilityInstancePk)
            const localVarPath = `/Account/{employeeFacilityInstancePk}/employee-profile-picture`
                .replace(`{${"employeeFacilityInstancePk"}}`, encodeURIComponent(String(employeeFacilityInstancePk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the profile picture of an employee.
         * @param {number} employeeFacilityInstancePk The unique ID of the employee.
         * @param {string} [body] The new profile picture as a string.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountEmployeeFacilityInstancePkEmployeeProfilePicturePut: async (employeeFacilityInstancePk: number, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeFacilityInstancePk' is not null or undefined
            assertParamExists('accountEmployeeFacilityInstancePkEmployeeProfilePicturePut', 'employeeFacilityInstancePk', employeeFacilityInstancePk)
            const localVarPath = `/Account/{employeeFacilityInstancePk}/employee-profile-picture`
                .replace(`{${"employeeFacilityInstancePk"}}`, encodeURIComponent(String(employeeFacilityInstancePk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login API for all roles
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountLoginPost: async (loginRequest?: LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * - Profiles are sourced from the `Secrets:ElasticSearchPeopleIndex` and filtered by the current user\'s SaaS Id.  - If Elasticsearch is unavailable, returns 503 Service Unavailable.  - If the user has no profiles, returns 200 with an empty `profiles` array.  - With `isWeb=true` (the portal) `profiles` holds every Desktop profile plus the Mobile profiles    the mobile app would list (not those at a facility that disabled the mobile app). Each profile    carries `webPunchAllowed`; a Mobile profile without it opens on an empty screen. Web punching    is the app punching permission.  - `tokenProfileRole` (\"Desktop\" or \"Mobile\") and `tokenProfileWebPunchAllowed` describe the profile    of the current session even when it is no longer in `profiles`, including after the WebPunch    release switch is turned off. A Mobile session gets the punch-only layout; a Desktop session    shows the Web Punch menu item when allowed.  - `tokenProfileWebPunchUnavailable` is true when that permission could not be read (the session\'s    facility was unreachable); `tokenProfileWebPunchAllowed` is then false for lack of an answer, and    a Mobile session should be offered a retry. Informational for a Desktop    session, whose Web Punch item comes from GET facility/menu.  - A request the caller abandoned answers 499 and is not logged as an error.
         * @summary Returns the authenticated user\'s identity information and all linked facility profiles from Elasticsearch.
         * @param {boolean} [isWeb] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountMeGet: async (isWeb?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isWeb !== undefined) {
                localVarQueryParameter['isWeb'] = isWeb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login API for mobile users
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        accountMobileLoginPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/mobile-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        accountMobileRegisterPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/mobile-register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RefreshTokenByJwtTokenRequest} [refreshTokenByJwtTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountRefreshTokenByTokenPost: async (refreshTokenByJwtTokenRequest?: RefreshTokenByJwtTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/refresh-token-by-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenByJwtTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RefreshTokenRequest} [refreshTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountRefreshTokenPost: async (refreshTokenRequest?: RefreshTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/refresh-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Saves logged-in user\'s profile selection and returns a refreshed login response.
         * @param {string} targetEmployeeId The ID of the employee to switch the user context to.
         * @param {boolean} [isWeb] Sent as true by the portal. Any of the user\&#39;s own profiles may be chosen; a Mobile profile  that may not web punch opens on an empty screen (its menu is empty). The mobile app does  not send it and is not affected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountSelectProfileTargetEmployeeIdPut: async (targetEmployeeId: string, isWeb?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetEmployeeId' is not null or undefined
            assertParamExists('accountSelectProfileTargetEmployeeIdPut', 'targetEmployeeId', targetEmployeeId)
            const localVarPath = `/Account/select-profile/{targetEmployeeId}`
                .replace(`{${"targetEmployeeId"}}`, encodeURIComponent(String(targetEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isWeb !== undefined) {
                localVarQueryParameter['isWeb'] = isWeb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProfileUpdateRequest} [profileUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUpdateProfilePicturePut: async (profileUpdateRequest?: ProfileUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/update-profile-picture`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {PasswordResetRequest} [passwordResetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUsernameResetPasswordPatch: async (username: string, passwordResetRequest?: PasswordResetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('accountUsernameResetPasswordPatch', 'username', username)
            const localVarPath = `/Account/{username}/reset-password`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        accountUsernameSendResetPasswordOtpPost: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('accountUsernameSendResetPasswordOtpPost', 'username', username)
            const localVarPath = `/Account/{username}/send-reset-password-otp`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        accountUsernameSendResetPasswordOtpSmsPost: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('accountUsernameSendResetPasswordOtpSmsPost', 'username', username)
            const localVarPath = `/Account/{username}/send-reset-password-otp-sms`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {VerifyOtpForPasswordResettingRequest} [verifyOtpForPasswordResettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUsernameVerifyOtpForPasswordResetPost: async (username: string, verifyOtpForPasswordResettingRequest?: VerifyOtpForPasswordResettingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('accountUsernameVerifyOtpForPasswordResetPost', 'username', username)
            const localVarPath = `/Account/{username}/verify-otp-for-password-reset`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyOtpForPasswordResettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends an OTP to the provided phone number - either an initial registration OTP or a password reset OTP,  depending on if the user is already registered in the SaaS.  Note that if the user is not already registered in the SaaS, an OTP will not be sent if either: the  provided phone number does not exist in at least one legacy facility profile, or none of the matched  facilities have mobile access (see AccessibleFacilities on the response).  IsNewUser reflects the real account state again as of SPD-5740, reverting SPD-5470\'s hardcoded  true - the frontend\'s forgot-password flow still branches on this value and can\'t yet move to  the accurate, dedicated v3/request-password-reset-otp flow. This re-opens the phone-number  enumeration gap SPD-5470 closed (this endpoint is unauthenticated and Obsolete); remove once  the frontend migrates.
         * @param {string} phoneNumber The phone number to send an OTP to
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        accountV2PhoneNumberSendOtpPost: async (phoneNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('accountV2PhoneNumberSendOtpPost', 'phoneNumber', phoneNumber)
            const localVarPath = `/Account/v2/{phoneNumber}/send-otp`
                .replace(`{${"phoneNumber"}}`, encodeURIComponent(String(phoneNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Registers the user using a provided registration OTP.  All profiles with the provided phone number - across all legacy facilities - will be linked to this user.  Note that this endpoint does not support linking additional profiles to an existing user, this is only for  initial registration.  To link additional profiles to an existing user, call the ``/admin/users/{id}/link-profiles`` endpoint
         * @param {RegisterRequestV2} [registerRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2RegisterPost: async (registerRequestV2?: RegisterRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/v2/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends a password reset OTP to the provided phone number, if the inputted username, phone, and dob match
         * @param {ResetPasswordOtpRequest} [resetPasswordOtpRequest] Request containing the username, phone number to send OTP and DOB of user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV3RequestPasswordResetOtpPost: async (resetPasswordOtpRequest?: ResetPasswordOtpRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/v3/request-password-reset-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends a registration OTP to the provided phone number.  Throws (403, same message in all three cases to avoid revealing which one applies to an  unauthenticated caller) if an account already exists for this phone number, if the phone  number/date-of-birth combination does not match any legacy facility profile, or if none of  the matched facilities have mobile access.
         * @param {SendRegistrationOtpRequest} [sendRegistrationOtpRequest] Request containing phone number and date of birth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV3SendRegistrationOtpPost: async (sendRegistrationOtpRequest?: SendRegistrationOtpRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/v3/send-registration-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendRegistrationOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends a password reset OTP to the provided phone number, if the inputted username, phone, and dob match
         * @param {RetrieveUsernameOtpRequest} [retrieveUsernameOtpRequest] Request containing the username, phone number to send OTP and DOB of user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV3SendRetrieveUsernameOtpPost: async (retrieveUsernameOtpRequest?: RetrieveUsernameOtpRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/v3/send-retrieve-username-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retrieveUsernameOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint logs both successful and unsuccessful verification attempts.
         * @summary Verifies the OTP provided for username retrieval and, upon successful verification,  sends an SMS containing the associated username to the user.
         * @param {VerifyOtpForUserRetrievalRequest} [verifyOtpForUserRetrievalRequest] The request payload containing the phone number and OTP needed for verification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV3VerifyOtpAndSendSmsForUsernameRetrievalPost: async (verifyOtpForUserRetrievalRequest?: VerifyOtpForUserRetrievalRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/v3/verify-otp-and-send-sms-for-username-retrieval`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyOtpForUserRetrievalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint logs both successful and unsuccessful verification attempts.
         * @summary Verifies the registration OTP
         * @param {VerifyOtpForUserRetrievalRequest} [verifyOtpForUserRetrievalRequest] The request payload containing the phone number and OTP needed for verification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV3VerifyOtpForRegistrationPost: async (verifyOtpForUserRetrievalRequest?: VerifyOtpForUserRetrievalRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/v3/verify-otp-for-registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyOtpForUserRetrievalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verifies an account
         * @param {VerifyUsernameRequest} [verifyUsernameRequest] Request containing username to verify
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV3VerifyUsernamePost: async (verifyUsernameRequest?: VerifyUsernameRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Account/v3/verify-username`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyUsernameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary During registration, this endpoint will be called to validate unique usernames..
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountValidateUsernameGet: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('accountValidateUsernameGet', 'username', username)
            const localVarPath = `/Account/validate-username`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves the profile picture of an employee based on their employee ID and facility ID.
         * @param {number} employeeFacilityInstancePk The unique ID of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountEmployeeFacilityInstancePkEmployeeProfilePictureGet(employeeFacilityInstancePk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountEmployeeFacilityInstancePkEmployeeProfilePictureGet(employeeFacilityInstancePk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the profile picture of an employee.
         * @param {number} employeeFacilityInstancePk The unique ID of the employee.
         * @param {string} [body] The new profile picture as a string.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountEmployeeFacilityInstancePkEmployeeProfilePicturePut(employeeFacilityInstancePk: number, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountEmployeeFacilityInstancePkEmployeeProfilePicturePut(employeeFacilityInstancePk, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login API for all roles
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountLoginPost(loginRequest?: LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountLoginPost(loginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * - Profiles are sourced from the `Secrets:ElasticSearchPeopleIndex` and filtered by the current user\'s SaaS Id.  - If Elasticsearch is unavailable, returns 503 Service Unavailable.  - If the user has no profiles, returns 200 with an empty `profiles` array.  - With `isWeb=true` (the portal) `profiles` holds every Desktop profile plus the Mobile profiles    the mobile app would list (not those at a facility that disabled the mobile app). Each profile    carries `webPunchAllowed`; a Mobile profile without it opens on an empty screen. Web punching    is the app punching permission.  - `tokenProfileRole` (\"Desktop\" or \"Mobile\") and `tokenProfileWebPunchAllowed` describe the profile    of the current session even when it is no longer in `profiles`, including after the WebPunch    release switch is turned off. A Mobile session gets the punch-only layout; a Desktop session    shows the Web Punch menu item when allowed.  - `tokenProfileWebPunchUnavailable` is true when that permission could not be read (the session\'s    facility was unreachable); `tokenProfileWebPunchAllowed` is then false for lack of an answer, and    a Mobile session should be offered a retry. Informational for a Desktop    session, whose Web Punch item comes from GET facility/menu.  - A request the caller abandoned answers 499 and is not logged as an error.
         * @summary Returns the authenticated user\'s identity information and all linked facility profiles from Elasticsearch.
         * @param {boolean} [isWeb] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountMeGet(isWeb?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountMeGet(isWeb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Login API for mobile users
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async accountMobileLoginPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountMobileLoginPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async accountMobileRegisterPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountMobileRegisterPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RefreshTokenByJwtTokenRequest} [refreshTokenByJwtTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountRefreshTokenByTokenPost(refreshTokenByJwtTokenRequest?: RefreshTokenByJwtTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefreshTokenByJwtTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountRefreshTokenByTokenPost(refreshTokenByJwtTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RefreshTokenRequest} [refreshTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountRefreshTokenPost(refreshTokenRequest?: RefreshTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountRefreshTokenPost(refreshTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Saves logged-in user\'s profile selection and returns a refreshed login response.
         * @param {string} targetEmployeeId The ID of the employee to switch the user context to.
         * @param {boolean} [isWeb] Sent as true by the portal. Any of the user\&#39;s own profiles may be chosen; a Mobile profile  that may not web punch opens on an empty screen (its menu is empty). The mobile app does  not send it and is not affected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountSelectProfileTargetEmployeeIdPut(targetEmployeeId: string, isWeb?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountSelectProfileTargetEmployeeIdPut(targetEmployeeId, isWeb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProfileUpdateRequest} [profileUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountUpdateProfilePicturePut(profileUpdateRequest?: ProfileUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountUpdateProfilePicturePut(profileUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} username 
         * @param {PasswordResetRequest} [passwordResetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountUsernameResetPasswordPatch(username: string, passwordResetRequest?: PasswordResetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountUsernameResetPasswordPatch(username, passwordResetRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async accountUsernameSendResetPasswordOtpPost(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendOtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountUsernameSendResetPasswordOtpPost(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async accountUsernameSendResetPasswordOtpSmsPost(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountUsernameSendResetPasswordOtpSmsPost(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} username 
         * @param {VerifyOtpForPasswordResettingRequest} [verifyOtpForPasswordResettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountUsernameVerifyOtpForPasswordResetPost(username: string, verifyOtpForPasswordResettingRequest?: VerifyOtpForPasswordResettingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountUsernameVerifyOtpForPasswordResetPost(username, verifyOtpForPasswordResettingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sends an OTP to the provided phone number - either an initial registration OTP or a password reset OTP,  depending on if the user is already registered in the SaaS.  Note that if the user is not already registered in the SaaS, an OTP will not be sent if either: the  provided phone number does not exist in at least one legacy facility profile, or none of the matched  facilities have mobile access (see AccessibleFacilities on the response).  IsNewUser reflects the real account state again as of SPD-5740, reverting SPD-5470\'s hardcoded  true - the frontend\'s forgot-password flow still branches on this value and can\'t yet move to  the accurate, dedicated v3/request-password-reset-otp flow. This re-opens the phone-number  enumeration gap SPD-5470 closed (this endpoint is unauthenticated and Obsolete); remove once  the frontend migrates.
         * @param {string} phoneNumber The phone number to send an OTP to
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async accountV2PhoneNumberSendOtpPost(phoneNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendOtpV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountV2PhoneNumberSendOtpPost(phoneNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Registers the user using a provided registration OTP.  All profiles with the provided phone number - across all legacy facilities - will be linked to this user.  Note that this endpoint does not support linking additional profiles to an existing user, this is only for  initial registration.  To link additional profiles to an existing user, call the ``/admin/users/{id}/link-profiles`` endpoint
         * @param {RegisterRequestV2} [registerRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountV2RegisterPost(registerRequestV2?: RegisterRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountV2RegisterPost(registerRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sends a password reset OTP to the provided phone number, if the inputted username, phone, and dob match
         * @param {ResetPasswordOtpRequest} [resetPasswordOtpRequest] Request containing the username, phone number to send OTP and DOB of user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountV3RequestPasswordResetOtpPost(resetPasswordOtpRequest?: ResetPasswordOtpRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountV3RequestPasswordResetOtpPost(resetPasswordOtpRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sends a registration OTP to the provided phone number.  Throws (403, same message in all three cases to avoid revealing which one applies to an  unauthenticated caller) if an account already exists for this phone number, if the phone  number/date-of-birth combination does not match any legacy facility profile, or if none of  the matched facilities have mobile access.
         * @param {SendRegistrationOtpRequest} [sendRegistrationOtpRequest] Request containing phone number and date of birth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountV3SendRegistrationOtpPost(sendRegistrationOtpRequest?: SendRegistrationOtpRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountV3SendRegistrationOtpPost(sendRegistrationOtpRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sends a password reset OTP to the provided phone number, if the inputted username, phone, and dob match
         * @param {RetrieveUsernameOtpRequest} [retrieveUsernameOtpRequest] Request containing the username, phone number to send OTP and DOB of user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountV3SendRetrieveUsernameOtpPost(retrieveUsernameOtpRequest?: RetrieveUsernameOtpRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountV3SendRetrieveUsernameOtpPost(retrieveUsernameOtpRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint logs both successful and unsuccessful verification attempts.
         * @summary Verifies the OTP provided for username retrieval and, upon successful verification,  sends an SMS containing the associated username to the user.
         * @param {VerifyOtpForUserRetrievalRequest} [verifyOtpForUserRetrievalRequest] The request payload containing the phone number and OTP needed for verification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountV3VerifyOtpAndSendSmsForUsernameRetrievalPost(verifyOtpForUserRetrievalRequest?: VerifyOtpForUserRetrievalRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountV3VerifyOtpAndSendSmsForUsernameRetrievalPost(verifyOtpForUserRetrievalRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint logs both successful and unsuccessful verification attempts.
         * @summary Verifies the registration OTP
         * @param {VerifyOtpForUserRetrievalRequest} [verifyOtpForUserRetrievalRequest] The request payload containing the phone number and OTP needed for verification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountV3VerifyOtpForRegistrationPost(verifyOtpForUserRetrievalRequest?: VerifyOtpForUserRetrievalRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountV3VerifyOtpForRegistrationPost(verifyOtpForUserRetrievalRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verifies an account
         * @param {VerifyUsernameRequest} [verifyUsernameRequest] Request containing username to verify
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountV3VerifyUsernamePost(verifyUsernameRequest?: VerifyUsernameRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountV3VerifyUsernamePost(verifyUsernameRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary During registration, this endpoint will be called to validate unique usernames..
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accountValidateUsernameGet(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateUsernameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accountValidateUsernameGet(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves the profile picture of an employee based on their employee ID and facility ID.
         * @param {AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePictureGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountEmployeeFacilityInstancePkEmployeeProfilePictureGet(requestParameters: AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePictureGetRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.accountEmployeeFacilityInstancePkEmployeeProfilePictureGet(requestParameters.employeeFacilityInstancePk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the profile picture of an employee.
         * @param {AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePicturePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountEmployeeFacilityInstancePkEmployeeProfilePicturePut(requestParameters: AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePicturePutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.accountEmployeeFacilityInstancePkEmployeeProfilePicturePut(requestParameters.employeeFacilityInstancePk, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login API for all roles
         * @param {AccountApiAccountLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountLoginPost(requestParameters: AccountApiAccountLoginPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.accountLoginPost(requestParameters.loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * - Profiles are sourced from the `Secrets:ElasticSearchPeopleIndex` and filtered by the current user\'s SaaS Id.  - If Elasticsearch is unavailable, returns 503 Service Unavailable.  - If the user has no profiles, returns 200 with an empty `profiles` array.  - With `isWeb=true` (the portal) `profiles` holds every Desktop profile plus the Mobile profiles    the mobile app would list (not those at a facility that disabled the mobile app). Each profile    carries `webPunchAllowed`; a Mobile profile without it opens on an empty screen. Web punching    is the app punching permission.  - `tokenProfileRole` (\"Desktop\" or \"Mobile\") and `tokenProfileWebPunchAllowed` describe the profile    of the current session even when it is no longer in `profiles`, including after the WebPunch    release switch is turned off. A Mobile session gets the punch-only layout; a Desktop session    shows the Web Punch menu item when allowed.  - `tokenProfileWebPunchUnavailable` is true when that permission could not be read (the session\'s    facility was unreachable); `tokenProfileWebPunchAllowed` is then false for lack of an answer, and    a Mobile session should be offered a retry. Informational for a Desktop    session, whose Web Punch item comes from GET facility/menu.  - A request the caller abandoned answers 499 and is not logged as an error.
         * @summary Returns the authenticated user\'s identity information and all linked facility profiles from Elasticsearch.
         * @param {AccountApiAccountMeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountMeGet(requestParameters: AccountApiAccountMeGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<UserProfileResponse> {
            return localVarFp.accountMeGet(requestParameters.isWeb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login API for mobile users
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        accountMobileLoginPost(options?: AxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.accountMobileLoginPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        accountMobileRegisterPost(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.accountMobileRegisterPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiAccountRefreshTokenByTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountRefreshTokenByTokenPost(requestParameters: AccountApiAccountRefreshTokenByTokenPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<RefreshTokenByJwtTokenResponse> {
            return localVarFp.accountRefreshTokenByTokenPost(requestParameters.refreshTokenByJwtTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiAccountRefreshTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountRefreshTokenPost(requestParameters: AccountApiAccountRefreshTokenPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.accountRefreshTokenPost(requestParameters.refreshTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Saves logged-in user\'s profile selection and returns a refreshed login response.
         * @param {AccountApiAccountSelectProfileTargetEmployeeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountSelectProfileTargetEmployeeIdPut(requestParameters: AccountApiAccountSelectProfileTargetEmployeeIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.accountSelectProfileTargetEmployeeIdPut(requestParameters.targetEmployeeId, requestParameters.isWeb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiAccountUpdateProfilePicturePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUpdateProfilePicturePut(requestParameters: AccountApiAccountUpdateProfilePicturePutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.accountUpdateProfilePicturePut(requestParameters.profileUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiAccountUsernameResetPasswordPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUsernameResetPasswordPatch(requestParameters: AccountApiAccountUsernameResetPasswordPatchRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.accountUsernameResetPasswordPatch(requestParameters.username, requestParameters.passwordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiAccountUsernameSendResetPasswordOtpPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        accountUsernameSendResetPasswordOtpPost(requestParameters: AccountApiAccountUsernameSendResetPasswordOtpPostRequest, options?: AxiosRequestConfig): AxiosPromise<SendOtpResponse> {
            return localVarFp.accountUsernameSendResetPasswordOtpPost(requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiAccountUsernameSendResetPasswordOtpSmsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        accountUsernameSendResetPasswordOtpSmsPost(requestParameters: AccountApiAccountUsernameSendResetPasswordOtpSmsPostRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.accountUsernameSendResetPasswordOtpSmsPost(requestParameters.username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountApiAccountUsernameVerifyOtpForPasswordResetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountUsernameVerifyOtpForPasswordResetPost(requestParameters: AccountApiAccountUsernameVerifyOtpForPasswordResetPostRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.accountUsernameVerifyOtpForPasswordResetPost(requestParameters.username, requestParameters.verifyOtpForPasswordResettingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends an OTP to the provided phone number - either an initial registration OTP or a password reset OTP,  depending on if the user is already registered in the SaaS.  Note that if the user is not already registered in the SaaS, an OTP will not be sent if either: the  provided phone number does not exist in at least one legacy facility profile, or none of the matched  facilities have mobile access (see AccessibleFacilities on the response).  IsNewUser reflects the real account state again as of SPD-5740, reverting SPD-5470\'s hardcoded  true - the frontend\'s forgot-password flow still branches on this value and can\'t yet move to  the accurate, dedicated v3/request-password-reset-otp flow. This re-opens the phone-number  enumeration gap SPD-5470 closed (this endpoint is unauthenticated and Obsolete); remove once  the frontend migrates.
         * @param {AccountApiAccountV2PhoneNumberSendOtpPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        accountV2PhoneNumberSendOtpPost(requestParameters: AccountApiAccountV2PhoneNumberSendOtpPostRequest, options?: AxiosRequestConfig): AxiosPromise<SendOtpV2Response> {
            return localVarFp.accountV2PhoneNumberSendOtpPost(requestParameters.phoneNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Registers the user using a provided registration OTP.  All profiles with the provided phone number - across all legacy facilities - will be linked to this user.  Note that this endpoint does not support linking additional profiles to an existing user, this is only for  initial registration.  To link additional profiles to an existing user, call the ``/admin/users/{id}/link-profiles`` endpoint
         * @param {AccountApiAccountV2RegisterPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV2RegisterPost(requestParameters: AccountApiAccountV2RegisterPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<RegisterResponseV2> {
            return localVarFp.accountV2RegisterPost(requestParameters.registerRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends a password reset OTP to the provided phone number, if the inputted username, phone, and dob match
         * @param {AccountApiAccountV3RequestPasswordResetOtpPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV3RequestPasswordResetOtpPost(requestParameters: AccountApiAccountV3RequestPasswordResetOtpPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.accountV3RequestPasswordResetOtpPost(requestParameters.resetPasswordOtpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends a registration OTP to the provided phone number.  Throws (403, same message in all three cases to avoid revealing which one applies to an  unauthenticated caller) if an account already exists for this phone number, if the phone  number/date-of-birth combination does not match any legacy facility profile, or if none of  the matched facilities have mobile access.
         * @param {AccountApiAccountV3SendRegistrationOtpPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV3SendRegistrationOtpPost(requestParameters: AccountApiAccountV3SendRegistrationOtpPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.accountV3SendRegistrationOtpPost(requestParameters.sendRegistrationOtpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sends a password reset OTP to the provided phone number, if the inputted username, phone, and dob match
         * @param {AccountApiAccountV3SendRetrieveUsernameOtpPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV3SendRetrieveUsernameOtpPost(requestParameters: AccountApiAccountV3SendRetrieveUsernameOtpPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.accountV3SendRetrieveUsernameOtpPost(requestParameters.retrieveUsernameOtpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint logs both successful and unsuccessful verification attempts.
         * @summary Verifies the OTP provided for username retrieval and, upon successful verification,  sends an SMS containing the associated username to the user.
         * @param {AccountApiAccountV3VerifyOtpAndSendSmsForUsernameRetrievalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV3VerifyOtpAndSendSmsForUsernameRetrievalPost(requestParameters: AccountApiAccountV3VerifyOtpAndSendSmsForUsernameRetrievalPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.accountV3VerifyOtpAndSendSmsForUsernameRetrievalPost(requestParameters.verifyOtpForUserRetrievalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint logs both successful and unsuccessful verification attempts.
         * @summary Verifies the registration OTP
         * @param {AccountApiAccountV3VerifyOtpForRegistrationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV3VerifyOtpForRegistrationPost(requestParameters: AccountApiAccountV3VerifyOtpForRegistrationPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.accountV3VerifyOtpForRegistrationPost(requestParameters.verifyOtpForUserRetrievalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verifies an account
         * @param {AccountApiAccountV3VerifyUsernamePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountV3VerifyUsernamePost(requestParameters: AccountApiAccountV3VerifyUsernamePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.accountV3VerifyUsernamePost(requestParameters.verifyUsernameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary During registration, this endpoint will be called to validate unique usernames..
         * @param {AccountApiAccountValidateUsernameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountValidateUsernameGet(requestParameters: AccountApiAccountValidateUsernameGetRequest, options?: AxiosRequestConfig): AxiosPromise<ValidateUsernameResponse> {
            return localVarFp.accountValidateUsernameGet(requestParameters.username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for accountEmployeeFacilityInstancePkEmployeeProfilePictureGet operation in AccountApi.
 * @export
 * @interface AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePictureGetRequest
 */
export interface AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePictureGetRequest {
    /**
     * The unique ID of the employee.
     * @type {number}
     * @memberof AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePictureGet
     */
    readonly employeeFacilityInstancePk: number
}

/**
 * Request parameters for accountEmployeeFacilityInstancePkEmployeeProfilePicturePut operation in AccountApi.
 * @export
 * @interface AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePicturePutRequest
 */
export interface AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePicturePutRequest {
    /**
     * The unique ID of the employee.
     * @type {number}
     * @memberof AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePicturePut
     */
    readonly employeeFacilityInstancePk: number

    /**
     * The new profile picture as a string.
     * @type {string}
     * @memberof AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePicturePut
     */
    readonly body?: string
}

/**
 * Request parameters for accountLoginPost operation in AccountApi.
 * @export
 * @interface AccountApiAccountLoginPostRequest
 */
export interface AccountApiAccountLoginPostRequest {
    /**
     * 
     * @type {LoginRequest}
     * @memberof AccountApiAccountLoginPost
     */
    readonly loginRequest?: LoginRequest
}

/**
 * Request parameters for accountMeGet operation in AccountApi.
 * @export
 * @interface AccountApiAccountMeGetRequest
 */
export interface AccountApiAccountMeGetRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AccountApiAccountMeGet
     */
    readonly isWeb?: boolean
}

/**
 * Request parameters for accountRefreshTokenByTokenPost operation in AccountApi.
 * @export
 * @interface AccountApiAccountRefreshTokenByTokenPostRequest
 */
export interface AccountApiAccountRefreshTokenByTokenPostRequest {
    /**
     * 
     * @type {RefreshTokenByJwtTokenRequest}
     * @memberof AccountApiAccountRefreshTokenByTokenPost
     */
    readonly refreshTokenByJwtTokenRequest?: RefreshTokenByJwtTokenRequest
}

/**
 * Request parameters for accountRefreshTokenPost operation in AccountApi.
 * @export
 * @interface AccountApiAccountRefreshTokenPostRequest
 */
export interface AccountApiAccountRefreshTokenPostRequest {
    /**
     * 
     * @type {RefreshTokenRequest}
     * @memberof AccountApiAccountRefreshTokenPost
     */
    readonly refreshTokenRequest?: RefreshTokenRequest
}

/**
 * Request parameters for accountSelectProfileTargetEmployeeIdPut operation in AccountApi.
 * @export
 * @interface AccountApiAccountSelectProfileTargetEmployeeIdPutRequest
 */
export interface AccountApiAccountSelectProfileTargetEmployeeIdPutRequest {
    /**
     * The ID of the employee to switch the user context to.
     * @type {string}
     * @memberof AccountApiAccountSelectProfileTargetEmployeeIdPut
     */
    readonly targetEmployeeId: string

    /**
     * Sent as true by the portal. Any of the user\&#39;s own profiles may be chosen; a Mobile profile  that may not web punch opens on an empty screen (its menu is empty). The mobile app does  not send it and is not affected.
     * @type {boolean}
     * @memberof AccountApiAccountSelectProfileTargetEmployeeIdPut
     */
    readonly isWeb?: boolean
}

/**
 * Request parameters for accountUpdateProfilePicturePut operation in AccountApi.
 * @export
 * @interface AccountApiAccountUpdateProfilePicturePutRequest
 */
export interface AccountApiAccountUpdateProfilePicturePutRequest {
    /**
     * 
     * @type {ProfileUpdateRequest}
     * @memberof AccountApiAccountUpdateProfilePicturePut
     */
    readonly profileUpdateRequest?: ProfileUpdateRequest
}

/**
 * Request parameters for accountUsernameResetPasswordPatch operation in AccountApi.
 * @export
 * @interface AccountApiAccountUsernameResetPasswordPatchRequest
 */
export interface AccountApiAccountUsernameResetPasswordPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountApiAccountUsernameResetPasswordPatch
     */
    readonly username: string

    /**
     * 
     * @type {PasswordResetRequest}
     * @memberof AccountApiAccountUsernameResetPasswordPatch
     */
    readonly passwordResetRequest?: PasswordResetRequest
}

/**
 * Request parameters for accountUsernameSendResetPasswordOtpPost operation in AccountApi.
 * @export
 * @interface AccountApiAccountUsernameSendResetPasswordOtpPostRequest
 */
export interface AccountApiAccountUsernameSendResetPasswordOtpPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountApiAccountUsernameSendResetPasswordOtpPost
     */
    readonly username: string
}

/**
 * Request parameters for accountUsernameSendResetPasswordOtpSmsPost operation in AccountApi.
 * @export
 * @interface AccountApiAccountUsernameSendResetPasswordOtpSmsPostRequest
 */
export interface AccountApiAccountUsernameSendResetPasswordOtpSmsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountApiAccountUsernameSendResetPasswordOtpSmsPost
     */
    readonly username: string
}

/**
 * Request parameters for accountUsernameVerifyOtpForPasswordResetPost operation in AccountApi.
 * @export
 * @interface AccountApiAccountUsernameVerifyOtpForPasswordResetPostRequest
 */
export interface AccountApiAccountUsernameVerifyOtpForPasswordResetPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountApiAccountUsernameVerifyOtpForPasswordResetPost
     */
    readonly username: string

    /**
     * 
     * @type {VerifyOtpForPasswordResettingRequest}
     * @memberof AccountApiAccountUsernameVerifyOtpForPasswordResetPost
     */
    readonly verifyOtpForPasswordResettingRequest?: VerifyOtpForPasswordResettingRequest
}

/**
 * Request parameters for accountV2PhoneNumberSendOtpPost operation in AccountApi.
 * @export
 * @interface AccountApiAccountV2PhoneNumberSendOtpPostRequest
 */
export interface AccountApiAccountV2PhoneNumberSendOtpPostRequest {
    /**
     * The phone number to send an OTP to
     * @type {string}
     * @memberof AccountApiAccountV2PhoneNumberSendOtpPost
     */
    readonly phoneNumber: string
}

/**
 * Request parameters for accountV2RegisterPost operation in AccountApi.
 * @export
 * @interface AccountApiAccountV2RegisterPostRequest
 */
export interface AccountApiAccountV2RegisterPostRequest {
    /**
     * 
     * @type {RegisterRequestV2}
     * @memberof AccountApiAccountV2RegisterPost
     */
    readonly registerRequestV2?: RegisterRequestV2
}

/**
 * Request parameters for accountV3RequestPasswordResetOtpPost operation in AccountApi.
 * @export
 * @interface AccountApiAccountV3RequestPasswordResetOtpPostRequest
 */
export interface AccountApiAccountV3RequestPasswordResetOtpPostRequest {
    /**
     * Request containing the username, phone number to send OTP and DOB of user
     * @type {ResetPasswordOtpRequest}
     * @memberof AccountApiAccountV3RequestPasswordResetOtpPost
     */
    readonly resetPasswordOtpRequest?: ResetPasswordOtpRequest
}

/**
 * Request parameters for accountV3SendRegistrationOtpPost operation in AccountApi.
 * @export
 * @interface AccountApiAccountV3SendRegistrationOtpPostRequest
 */
export interface AccountApiAccountV3SendRegistrationOtpPostRequest {
    /**
     * Request containing phone number and date of birth
     * @type {SendRegistrationOtpRequest}
     * @memberof AccountApiAccountV3SendRegistrationOtpPost
     */
    readonly sendRegistrationOtpRequest?: SendRegistrationOtpRequest
}

/**
 * Request parameters for accountV3SendRetrieveUsernameOtpPost operation in AccountApi.
 * @export
 * @interface AccountApiAccountV3SendRetrieveUsernameOtpPostRequest
 */
export interface AccountApiAccountV3SendRetrieveUsernameOtpPostRequest {
    /**
     * Request containing the username, phone number to send OTP and DOB of user
     * @type {RetrieveUsernameOtpRequest}
     * @memberof AccountApiAccountV3SendRetrieveUsernameOtpPost
     */
    readonly retrieveUsernameOtpRequest?: RetrieveUsernameOtpRequest
}

/**
 * Request parameters for accountV3VerifyOtpAndSendSmsForUsernameRetrievalPost operation in AccountApi.
 * @export
 * @interface AccountApiAccountV3VerifyOtpAndSendSmsForUsernameRetrievalPostRequest
 */
export interface AccountApiAccountV3VerifyOtpAndSendSmsForUsernameRetrievalPostRequest {
    /**
     * The request payload containing the phone number and OTP needed for verification.
     * @type {VerifyOtpForUserRetrievalRequest}
     * @memberof AccountApiAccountV3VerifyOtpAndSendSmsForUsernameRetrievalPost
     */
    readonly verifyOtpForUserRetrievalRequest?: VerifyOtpForUserRetrievalRequest
}

/**
 * Request parameters for accountV3VerifyOtpForRegistrationPost operation in AccountApi.
 * @export
 * @interface AccountApiAccountV3VerifyOtpForRegistrationPostRequest
 */
export interface AccountApiAccountV3VerifyOtpForRegistrationPostRequest {
    /**
     * The request payload containing the phone number and OTP needed for verification.
     * @type {VerifyOtpForUserRetrievalRequest}
     * @memberof AccountApiAccountV3VerifyOtpForRegistrationPost
     */
    readonly verifyOtpForUserRetrievalRequest?: VerifyOtpForUserRetrievalRequest
}

/**
 * Request parameters for accountV3VerifyUsernamePost operation in AccountApi.
 * @export
 * @interface AccountApiAccountV3VerifyUsernamePostRequest
 */
export interface AccountApiAccountV3VerifyUsernamePostRequest {
    /**
     * Request containing username to verify
     * @type {VerifyUsernameRequest}
     * @memberof AccountApiAccountV3VerifyUsernamePost
     */
    readonly verifyUsernameRequest?: VerifyUsernameRequest
}

/**
 * Request parameters for accountValidateUsernameGet operation in AccountApi.
 * @export
 * @interface AccountApiAccountValidateUsernameGetRequest
 */
export interface AccountApiAccountValidateUsernameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountApiAccountValidateUsernameGet
     */
    readonly username: string
}

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @summary Retrieves the profile picture of an employee based on their employee ID and facility ID.
     * @param {AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePictureGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountEmployeeFacilityInstancePkEmployeeProfilePictureGet(requestParameters: AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePictureGetRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountEmployeeFacilityInstancePkEmployeeProfilePictureGet(requestParameters.employeeFacilityInstancePk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the profile picture of an employee.
     * @param {AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePicturePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountEmployeeFacilityInstancePkEmployeeProfilePicturePut(requestParameters: AccountApiAccountEmployeeFacilityInstancePkEmployeeProfilePicturePutRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountEmployeeFacilityInstancePkEmployeeProfilePicturePut(requestParameters.employeeFacilityInstancePk, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login API for all roles
     * @param {AccountApiAccountLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountLoginPost(requestParameters: AccountApiAccountLoginPostRequest = {}, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountLoginPost(requestParameters.loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * - Profiles are sourced from the `Secrets:ElasticSearchPeopleIndex` and filtered by the current user\'s SaaS Id.  - If Elasticsearch is unavailable, returns 503 Service Unavailable.  - If the user has no profiles, returns 200 with an empty `profiles` array.  - With `isWeb=true` (the portal) `profiles` holds every Desktop profile plus the Mobile profiles    the mobile app would list (not those at a facility that disabled the mobile app). Each profile    carries `webPunchAllowed`; a Mobile profile without it opens on an empty screen. Web punching    is the app punching permission.  - `tokenProfileRole` (\"Desktop\" or \"Mobile\") and `tokenProfileWebPunchAllowed` describe the profile    of the current session even when it is no longer in `profiles`, including after the WebPunch    release switch is turned off. A Mobile session gets the punch-only layout; a Desktop session    shows the Web Punch menu item when allowed.  - `tokenProfileWebPunchUnavailable` is true when that permission could not be read (the session\'s    facility was unreachable); `tokenProfileWebPunchAllowed` is then false for lack of an answer, and    a Mobile session should be offered a retry. Informational for a Desktop    session, whose Web Punch item comes from GET facility/menu.  - A request the caller abandoned answers 499 and is not logged as an error.
     * @summary Returns the authenticated user\'s identity information and all linked facility profiles from Elasticsearch.
     * @param {AccountApiAccountMeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountMeGet(requestParameters: AccountApiAccountMeGetRequest = {}, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountMeGet(requestParameters.isWeb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login API for mobile users
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountMobileLoginPost(options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountMobileLoginPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountMobileRegisterPost(options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountMobileRegisterPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiAccountRefreshTokenByTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountRefreshTokenByTokenPost(requestParameters: AccountApiAccountRefreshTokenByTokenPostRequest = {}, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountRefreshTokenByTokenPost(requestParameters.refreshTokenByJwtTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiAccountRefreshTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountRefreshTokenPost(requestParameters: AccountApiAccountRefreshTokenPostRequest = {}, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountRefreshTokenPost(requestParameters.refreshTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Saves logged-in user\'s profile selection and returns a refreshed login response.
     * @param {AccountApiAccountSelectProfileTargetEmployeeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountSelectProfileTargetEmployeeIdPut(requestParameters: AccountApiAccountSelectProfileTargetEmployeeIdPutRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountSelectProfileTargetEmployeeIdPut(requestParameters.targetEmployeeId, requestParameters.isWeb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiAccountUpdateProfilePicturePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountUpdateProfilePicturePut(requestParameters: AccountApiAccountUpdateProfilePicturePutRequest = {}, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountUpdateProfilePicturePut(requestParameters.profileUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiAccountUsernameResetPasswordPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountUsernameResetPasswordPatch(requestParameters: AccountApiAccountUsernameResetPasswordPatchRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountUsernameResetPasswordPatch(requestParameters.username, requestParameters.passwordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiAccountUsernameSendResetPasswordOtpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountUsernameSendResetPasswordOtpPost(requestParameters: AccountApiAccountUsernameSendResetPasswordOtpPostRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountUsernameSendResetPasswordOtpPost(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiAccountUsernameSendResetPasswordOtpSmsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountUsernameSendResetPasswordOtpSmsPost(requestParameters: AccountApiAccountUsernameSendResetPasswordOtpSmsPostRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountUsernameSendResetPasswordOtpSmsPost(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountApiAccountUsernameVerifyOtpForPasswordResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountUsernameVerifyOtpForPasswordResetPost(requestParameters: AccountApiAccountUsernameVerifyOtpForPasswordResetPostRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountUsernameVerifyOtpForPasswordResetPost(requestParameters.username, requestParameters.verifyOtpForPasswordResettingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends an OTP to the provided phone number - either an initial registration OTP or a password reset OTP,  depending on if the user is already registered in the SaaS.  Note that if the user is not already registered in the SaaS, an OTP will not be sent if either: the  provided phone number does not exist in at least one legacy facility profile, or none of the matched  facilities have mobile access (see AccessibleFacilities on the response).  IsNewUser reflects the real account state again as of SPD-5740, reverting SPD-5470\'s hardcoded  true - the frontend\'s forgot-password flow still branches on this value and can\'t yet move to  the accurate, dedicated v3/request-password-reset-otp flow. This re-opens the phone-number  enumeration gap SPD-5470 closed (this endpoint is unauthenticated and Obsolete); remove once  the frontend migrates.
     * @param {AccountApiAccountV2PhoneNumberSendOtpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountV2PhoneNumberSendOtpPost(requestParameters: AccountApiAccountV2PhoneNumberSendOtpPostRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountV2PhoneNumberSendOtpPost(requestParameters.phoneNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Registers the user using a provided registration OTP.  All profiles with the provided phone number - across all legacy facilities - will be linked to this user.  Note that this endpoint does not support linking additional profiles to an existing user, this is only for  initial registration.  To link additional profiles to an existing user, call the ``/admin/users/{id}/link-profiles`` endpoint
     * @param {AccountApiAccountV2RegisterPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountV2RegisterPost(requestParameters: AccountApiAccountV2RegisterPostRequest = {}, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountV2RegisterPost(requestParameters.registerRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends a password reset OTP to the provided phone number, if the inputted username, phone, and dob match
     * @param {AccountApiAccountV3RequestPasswordResetOtpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountV3RequestPasswordResetOtpPost(requestParameters: AccountApiAccountV3RequestPasswordResetOtpPostRequest = {}, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountV3RequestPasswordResetOtpPost(requestParameters.resetPasswordOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends a registration OTP to the provided phone number.  Throws (403, same message in all three cases to avoid revealing which one applies to an  unauthenticated caller) if an account already exists for this phone number, if the phone  number/date-of-birth combination does not match any legacy facility profile, or if none of  the matched facilities have mobile access.
     * @param {AccountApiAccountV3SendRegistrationOtpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountV3SendRegistrationOtpPost(requestParameters: AccountApiAccountV3SendRegistrationOtpPostRequest = {}, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountV3SendRegistrationOtpPost(requestParameters.sendRegistrationOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sends a password reset OTP to the provided phone number, if the inputted username, phone, and dob match
     * @param {AccountApiAccountV3SendRetrieveUsernameOtpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountV3SendRetrieveUsernameOtpPost(requestParameters: AccountApiAccountV3SendRetrieveUsernameOtpPostRequest = {}, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountV3SendRetrieveUsernameOtpPost(requestParameters.retrieveUsernameOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint logs both successful and unsuccessful verification attempts.
     * @summary Verifies the OTP provided for username retrieval and, upon successful verification,  sends an SMS containing the associated username to the user.
     * @param {AccountApiAccountV3VerifyOtpAndSendSmsForUsernameRetrievalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountV3VerifyOtpAndSendSmsForUsernameRetrievalPost(requestParameters: AccountApiAccountV3VerifyOtpAndSendSmsForUsernameRetrievalPostRequest = {}, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountV3VerifyOtpAndSendSmsForUsernameRetrievalPost(requestParameters.verifyOtpForUserRetrievalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint logs both successful and unsuccessful verification attempts.
     * @summary Verifies the registration OTP
     * @param {AccountApiAccountV3VerifyOtpForRegistrationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountV3VerifyOtpForRegistrationPost(requestParameters: AccountApiAccountV3VerifyOtpForRegistrationPostRequest = {}, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountV3VerifyOtpForRegistrationPost(requestParameters.verifyOtpForUserRetrievalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verifies an account
     * @param {AccountApiAccountV3VerifyUsernamePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountV3VerifyUsernamePost(requestParameters: AccountApiAccountV3VerifyUsernamePostRequest = {}, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountV3VerifyUsernamePost(requestParameters.verifyUsernameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary During registration, this endpoint will be called to validate unique usernames..
     * @param {AccountApiAccountValidateUsernameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public accountValidateUsernameGet(requestParameters: AccountApiAccountValidateUsernameGetRequest, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).accountValidateUsernameGet(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }
}
